<!--
 * @Author: chenxing
 * @Date: 2021-04-08 11:05:08
 * @LastEditors: chenxing
 * @LastEditTime: 2021-12-20 14:37:28
-->
<template>
  <div>
    <div class="video_script w100 h100">
      <a-row class="filter_row">
        <a-col :span="1" style="line-height: 40px">筛选：</a-col>
        <a-col :span="3">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-select mode="multiple" v-model:value="filterConditions.makeIds" placeholder="请选择脚本名称" :max-tag-count="2" :filter-option="true" option-filter-prop="label" style="width: 100%" show-arrow allow-clear>
              <a-select-option v-for="scriptName in scriptNameOptions" :key="scriptName.value" :label="scriptName.label" :value="scriptName.value">{{ scriptName.label }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="3">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-select mode="multiple" v-model:value="filterConditions.projectCodes" placeholder="请选择所属产品" :max-tag-count="2" :filter-option="true" option-filter-prop="label" style="width: 100%" show-arrow allow-clear>
              <a-select-option v-for="project in projectOptions" :key="project.value" :label="project.label" :value="project.value">{{ project.label }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="3">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-tree-select
              mode="multiple"
              v-model:value="filterConditions.deptIds"
              :max-tag-count="2"
              :tree-data="deptTreeOptions"
              :field-names="{ label: 'label', value: 'value', children: 'children' }"
              tree-default-expand-all
              show-search
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择所属组"
              style="width: 100%"
              show-arrow
              allow-clear
            />
          </a-form-item>
        </a-col>
        <a-col :span="3">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-select mode="multiple" v-model:value="filterConditions.mouthPlays" :max-tag-count="2" placeholder="请选择脚本类型" style="width: 100%" :filter-option="true" option-filter-prop="label" :options="mouthplayOptions" show-arrow allow-clear> </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="4">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-range-picker :placeholder="['开始日期', '结束日期']" v-model:value="defaultRange" separator="到" :format="[dateRangeFormat, dateRangeFormat]" :allow-clear="false" @change="onDateRangeChange" @calendar-change="onCalendarChange" />
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-space class="float-r">
              <a-button type="primary" @click="onFilterBtnClick" :disabled="tableLoading">筛选</a-button>
              <a-button type="default" @click="onResetFilterBtnClick" :disabled="tableLoading">重置</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>

      <div class="table_wrapper w100 bcg_w">
        <a-row style="margin-bottom: 12px" v-hasPermission="`VIDEOSCRIPT_ADD`">
          <a-button type="primary" @click="onCreateScriptBtnClick" :disabled="tableLoading"><PlusCircleOutlined style="font-size: 14px" />添加脚本</a-button>
        </a-row>
        <a-table size="small" :data-source="tableData" :columns="tableColumns" row-key="makeId" :scroll="{ y: tableHeight }" :pagination="tablePagination" @change="onTableChange" :loading="tableLoading" bordered>
          <template #mouthPlay="{ record }">
            <div>
              {{ columnMap(mouthplayOptions, record.mouthPlay) }}
            </div>
          </template>
          <template #actor="{ record }">
            <div v-for="actor in record.actorInfoList" :key="actor.actorName" class="table-arr-box">
              {{ actor.actorName }}
            </div>
          </template>
          <template #shooting="{ record }">
            <div v-for="actor in record.shootingBOList" :key="actor.shooting_name" class="table-arr-box">
              {{ actor.shooting_name }}
            </div>
          </template>
          <template #screenwriter="{ record }">
            <div v-for="actor in record.screenwriterBOList" :key="actor.screenwriter_name" class="table-arr-box">
              {{ actor.screenwriter_name }}
            </div>
          </template>
          <template #actorPrice="{ record }">
            <div v-for="actor in record.actorInfoList" :key="actor.actorName" class="table-arr-box">
              {{ actor.cost }}
            </div>
          </template>
          <template #operation="{ record }">
            <div>
              <a-space>
                <a v-hasPermission="`VIDEOSCRIPT_EDIT`" @click="onTableEditClick(record)">编辑</a>
                <a-popconfirm v-hasPermission="`VIDEOSCRIPT_DELETE`" title="您确定要删除该脚本吗？" ok-text="删除" cancel-text="取消" @confirm="confirmDeleteScript(record)">
                  <a>删除</a>
                </a-popconfirm>
              </a-space>
            </div>
          </template>
        </a-table>
      </div>

      <!--    -->
      <a-modal class="add_script_modal" v-model:visible="createScriptModalVisible" :confirm-loading="onCreateScriptOKLoading" :title="!createScriptFormData.id ? '创建脚本' : '编辑脚本'"  @ok="onCreateScriptOK" @cancel="onCreateScriptModalCancel" ok-text="保存" cancel-text="取消"  :mask-closable="false" :width="700">
        <a-form ref="createScriptForm" :rules="createScriptFormRules" :model="createScriptFormData">
          <a-row>
            <a-col :span="12">
              <a-form-item label="脚本类型" name="mouthPlay" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-select v-model:value="createScriptFormData.mouthPlay" :options="mouthplayOptions" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="名称" name="makeName" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }"> <a-input v-model:value="createScriptFormData.makeName" placeholder="请输入脚本名称" /> </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item label="所属渠道" name="mediaChannelsArr" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-select mode="multiple" v-model:value="createScriptFormData.mediaChannelsArr" :options="mediaChannelOptions" placeholder="请选择媒体渠道" :filter-option="true" option-filter-prop="label" show-search show-arrow>
                  <a-select-option v-for="mediaChannelOption in mediaChannelOptions" :key="mediaChannelOption.value" :label="mediaChannelOption.label" :value="mediaChannelOption.value">{{ mediaChannelOption.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="产品" name="projectCode" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-select v-model:value="createScriptFormData.projectCode" :options="projectOptions" placeholder="请选择产品" :filter-option="true" option-filter-prop="label" show-search show-arrow>
                  <a-select-option v-for="project in projectOptions" :key="project.projectCode" :label="project.projectName" :value="project.projectCode">{{ project.projectName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="24">
              <a-form-item label="所属组" name="deptId" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-tree-select
                  v-model:value="createScriptFormData.deptId"
                  :tree-data="deptTreeOptions"
                  :field-names="{ label: 'label', value: 'value', children: 'children' }"
                  tree-default-expand-all
                  show-search
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  placeholder="请选择所属组"
                  show-arrow
                  @change="onDeptChange"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="时间" name="uploadTime" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-date-picker class="blue-icon" v-model:value="createScriptFormData.uploadTime" :disabled="createScriptFormData.id != null" placeholder="请选择时间" style="width: 100%" :allow-clear="false" @change="onScriptDateChange" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="编导" name="screenwriterArray" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-select :filter-option="true" option-filter-prop="label" mode="multiple" v-model:value="createScriptFormData.screenwriterArray" :options="scenaristOptions" :disabled="!createScriptFormData.deptId" placeholder="请选择编导" show-arrow />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="createScriptFormData.mouthPlay != 'YSJJ'">
            <a-col :span="24">
              <a-form-item label="参演艺人" name="actorIdArray" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                <a-select mode="multiple" v-model:value="createScriptFormData.actorIdArray" :filter-option="true" option-filter-prop="label" option-label-prop="label" :max-tag-count="3" placeholder="请选择参演艺人" show-arrow>
                  <a-select-option v-for="actor in actorOptions" :key="actor.key" :value="actor.value" :label="actor.text">
                    {{ actor.text }}
                    <label style="color: #bfbfbf">{{ `(￥${actor.cost})` }}</label>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="摄像" name="shootingArray" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <a-select :filter-option="true" option-filter-prop="label" mode="multiple" v-model:value="createScriptFormData.shootingArray" :value="item"  :options="phtographerOptions" :disabled="!createScriptFormData.deptId" placeholder="请选择摄像" show-arrow />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
    </div>
  </div>
</template>

<script>
import locale from 'ant-design-vue/es/locale/zh_CN';
import { getScriptListData, saveScriptData, getActorListDataByDate, deleteScriptData, getScriptNameListData } from '@/api/material/script.js';
import { getUserListDataByJob } from '@/api/base/user.js';
import { getProjectListData } from '@/api/base/project.js';
import { getDeptListDataByType } from '@/api/base/department.js';
import moment from 'moment';
import { getDocumentScroll } from '@/utils/utils.js';
import { PlusCircleOutlined } from '@ant-design/icons-vue';

export default {
  components: { PlusCircleOutlined },
  data() {
    return {
      mediaChannelOptions: [
        { label: '巨量引擎', value: '巨量引擎' },
        { label: '广点通', value: '广点通' },
        { label: '巨量千川', value: '巨量千川' },
        { label: '星广联投', value: '星广联投' },
        { label: '小红书', value: '小红书' },
        { label: '支付宝', value: '支付宝' },
        /*{ label: '巨量星广', value: '巨量星广' },*/
      ],
      locale,
      tableHeight: 1920,
      onCreateScriptOKLoading:false,
      createScriptModalVisible: false, //显示创建脚本会话框
      projectOptions: [],
      scriptNameOptions: [],
      actorOptions: [],
      deptOptions: [],
      phtographerOptions: [],
      phtographerOptionsMap: {},
      scenaristOptions: [], // 编导列表
      scenaristOptionsMap: {}, // 编导列表
      //口播，剧情，街采，多人分采，发布会 ，访谈，原生vlog，走播
      // { label: '口播', value: 'MP' },
      // { label: '剧情', value: 'JQ' },
      // { label: '街采', value: 'JC' },
      // { label: '多人分采', value: 'DRFC' },
      // { label: '发布会', value: 'FBH' },
      // { label: '访谈', value: 'FT' },
      // { label: '原生vlog', value: 'YS_VLOG' },
      // { label: '走播', value: 'ZB' },
      // { label: '口播', value: 'MP' },
      // { label: '耗时口播(废弃)', value: 'NOMP' },
      // { label: '情景剧(废弃)', value: 'QJJNOMP' },
      // { label: '剪辑(废弃)', value: 'YSJJ' },
      // { label: '采访(废弃)', value: 'CAIFANG' },
      mouthplayOptions: [
        { label: '口播', value: 'MP' },
        { label: '耗时口播', value: 'NOMP' },
        { label: '情景剧', value: 'QJJNOMP' },
        { label: '剪辑', value: 'YSJJ' },
        { label: '采访', value: 'CAIFANG' },
      ],
      defaultRange: [moment(), moment()],
      dateRangeFormat: 'YYYY-MM-DD',
      dates: [],
      createScriptFormData: {},
      createScriptFormRules: {
        makeName: { required: true, trigger: 'blur', message: '必填项' },
        deptId: { required: true, trigger: 'blur', message: '必选项' },
        mediaChannelsArr: { type: 'array', required: true, trigger: 'blur', message: '必选项' },
        projectCode: { required: true, trigger: 'blur', message: '必选项' },
        actorIdArray: { type: 'array', required: true, trigger: 'blur', message: '必选项' },
        // shootingId: { required: true, trigger: 'blur', message: '必选项' },
        shootingArray: {  type: 'array', required: true, trigger: 'blur', message: '必选项' },
        // screenwriterId: { required: true, trigger: 'blur', message: '必选项' },
        screenwriterArray: { type: 'array',  required: true, trigger: 'blur', message: '必选项' },
      },
      tableLoading: false,
      filterConditions: {
        startUploadTime: moment().format('YYYY-MM-DD'),
        endUploadTime: moment().format('YYYY-MM-DD'),
      },
      tableData: [],
      tableColumns: [
        {
          title: '时间',
          dataIndex: 'uploadTime',
          key: 'uploadTime',
          width: 100,
        },
        {
          title: '事业部',
          dataIndex: 'deptName',
          key: 'deptName',
          // width: 240,
        },
        {
          title: '产品名称',
          dataIndex: 'projectName',
          key: 'projectName',
          // width: 240,
        },
        {
          title: '脚本名称',
          dataIndex: 'makeName',
          key: 'makeName',
          // width: 240,
        },
        {
          title: '参演艺人',
          dataIndex: 'actorInfoList',
          key: 'actorInfoList',
          align: 'center',
          // width: 150,
          slots: {
            customRender: 'actor',
          },
        },
        {
          title: '成本（元/条）',
          dataIndex: 'actorInfoList',
          key: 'actorInfoList',
          align: 'center',
          // width: 150,
          slots: {
            customRender: 'actorPrice',
          },
        },
        {
          title: '摄像',
          dataIndex: 'userCode',
          key: 'userCode',
          // width: 120,
        },
        {
          title: '摄像集合',
          dataIndex: 'shootingBOList',
          key: 'shootingBOList',
          // width: 120,
          align: 'center',
          // width: 150,
          slots: {
            customRender: 'shooting',
          },
        },
        {
          title: '编导',
          dataIndex: 'screenwriterCode',
          key: 'screenwriterCode',
          // width: 120,
          align: 'center',
        },
        {
          title: '编导集合',
          dataIndex: 'screenwriterBOList',
          key: 'screenwriterBOList',
          // width: 120,
          align: 'center',
          // width: 150,
          slots: {
            customRender: 'screenwriter',
          },
        },
        {
          title: '脚本类型',
          dataIndex: 'mouthPlay',
          key: 'mouthPlay',
          // width: 120,
          slots: {
            customRender: 'mouthPlay',
          },
        },
        {
          title: '媒体渠道',
          dataIndex: 'mediaChannels',
          key: 'mediaChannels',
          // width: 120,
          slots: {
            customRender: 'mediaChannels',
          },
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 120,
          slots: {
            customRender: 'operation',
          },
        },
      ],
      tablePagination: {
        limit: '30',
        page: '1',
        pageSize: 30,
        showTotal: total => `总计${total}条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '50'],
      },
    };
  },
  created() {
    this.getProjectList();
    this.getScriptTableList();
    this.getDeptListByType();
    this.getScriptNameListData();
  },
  watch: {
    tableHeight(newVal) {
      this.tableHeight = newVal;
    },
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.tableHeight = getDocumentScroll();
      })();
    };
  },
  methods: {
    disabledDate(current) {
      if (!this.dates || this.dates.length === 0) {
        return false;
      }

      const diffDate = current.diff(this.dates[0], 'days');
      return Math.abs(diffDate) > 6;
    },
    columnMap(options, key) {
      if (key) {
        return options.filter(op => {
          return op.value === key;
        })[0].label;
      }
    },
    async getDeptListByType() {
      let res = await getDeptListDataByType({});
      // 只保留VIDEO类型的选项到deptOptions
      this.deptOptions = res.list.filter(d => d.deptType === 'VIDEO').map(d => {
        return { label: d.name, value: d.deptId };
      });
      
      // 转换为树形结构
      this.deptTreeOptions = this.convertToTree(res.list);
      
      this.tableHeight = getDocumentScroll();
    },
    
    // 将扁平的部门数据转换为树形结构
    convertToTree(list) {
      if (!list || !Array.isArray(list)) {
        return [];
      }
      
      // 创建一个映射，便于查找部门
      const deptMap = {};
      
      // 首先创建所有部门的映射
      list.forEach(item => {
        deptMap[item.deptId] = {
          value: item.deptId,
          label: item.name,
          deptType: item.deptType, // 保留原始数据中的deptType
          disabled: item.deptType !== 'VIDEO', // 非VIDEO类型的部门置灰
          children: []
        };
      });
      
      // 构建树形结构
      list.forEach(item => {
        const node = deptMap[item.deptId];
        
        // 如果有父部门且父部门存在于列表中
        if (item.parentId && deptMap[item.parentId]) {
          // 添加到父节点的children中
          deptMap[item.parentId].children.push(node);
        }
      });
      
      // 递归检查节点是否包含VIDEO类型的子节点
      const hasVideoDescendant = (node) => {
        if (node.deptType === 'VIDEO') {
          return true;
        }
        if (node.children && node.children.length > 0) {
          return node.children.some(child => hasVideoDescendant(child));
        }
        return false;
      };
      
      // 递归过滤节点
      const filterTree = (nodes) => {
        return nodes
          .filter(node => hasVideoDescendant(node)) // 只保留有VIDEO类型后代的节点
          .map(node => {
            return {
              ...node,
              children: filterTree(node.children) // 递归过滤子节点
            };
          });
      };
      
      // 获取所有根节点并过滤
      const roots = [];
      list.forEach(item => {
        if (!item.parentId || !deptMap[item.parentId]) {
          roots.push(deptMap[item.deptId]);
        }
      });
      
      // 过滤树结构
      return filterTree(roots);
    },
    //获取产品列表
    async getProjectList() {
      let res = await getProjectListData({});
      this.projectOptions = res.page.list.map(proj => {
        return {
          label: proj.projectName,
          value: proj.projectCode,
        };
      });
    },
    // 获取摄像列表
    async getPhotographerList() {
      // let res = await getUserListDataByJob({ job: 'PHOTOGRAPHER', deptId: this.createScriptFormData.deptId });
      let res = await getUserListDataByJob({ job: 'PHOTOGRAPHER',deptId: this.createScriptFormData.deptId ,findAll:true});
      var phtographerOptionsMapTemp = {};
      this.phtographerOptions = res.list.map(ph => {
        phtographerOptionsMapTemp[ph.userId.toString()] = ph.userCode;
        return {
          label: ph.userCode,
          value: ph.userId.toString(),
        };
      });
      this.phtographerOptionsMap = phtographerOptionsMapTemp;
      //console.log(this.phtographerOptions);
    },
    // 获取编导列表
    async getScenaristListByJob() {
      // let res = await getUserListDataByJob({ job: 'SCENARIST', deptId: this.createScriptFormData.deptId });
      let res = await getUserListDataByJob({ job: 'SCENARIST',deptId: this.createScriptFormData.deptId ,findAll:true});
      var scenaristOptionsMapTemp = {};
      this.scenaristOptions = res.list.map(ph => {
        scenaristOptionsMapTemp[ph.userId.toString()] = ph.userCode;
        return {
          label: ph.userCode,
          value: ph.userId.toString(),
        };
      });
      this.scenaristOptionsMap = scenaristOptionsMapTemp;
    },
    async getActorListByDate() {
      let res = await getActorListDataByDate({deptId:this.createScriptFormData.deptId, date: this.createScriptFormData.uploadTime.format(this.dateRangeFormat) });
      this.actorOptions = res.list.map(actor => {
        return {
          cost: actor.cost,
          text: actor.actorName,
          value: actor.actorId.toString(),
          key: actor.actorId.toString(),
        };
      });
    },
    // 获取数据
    async getScriptTableList() {
      if (this.tableLoading === true) {
        return;
      }
      this.tableLoading = true;
      let postData = { ...this.filterConditions, limit: this.tablePagination.limit, page: this.tablePagination.page };
      let res = await getScriptListData(postData);
      res.page.list.forEach(e => {
        if(e.mediaChannels){
          e.mediaChannelsArr = e.mediaChannels.split(",");
        }
      });
      this.tableData = res.page.list;
      this.tablePagination.current = res.page.currPage;
      this.tablePagination.pageSize = res.page.pageSize;
      this.tablePagination.total = res.page.totalCount;
      this.tableLoading = false;
    },
    async saveScript() {
      console.error('===========saveScript=========');
      console.error(this.scenaristOptions);
      let postData = { ...this.createScriptFormData, actorIdArray: [], shootingBOList:[],screenwriterBOList:[],uploadTime: this.createScriptFormData.uploadTime.format(this.dateRangeFormat) ,mediaChannels:[]};

      this.createScriptFormData.actorIdArray.forEach(actor => {
        postData.actorIdArray.push(actor);
      });
      this.createScriptFormData.mediaChannelsArr = this.createScriptFormData.mediaChannelsArr.sort();

      postData.mediaChannels = this.createScriptFormData.mediaChannelsArr.join(',');

      if(this.createScriptFormData.screenwriterArray){
        this.createScriptFormData.screenwriterArray.forEach(screenwriter => {
          postData.screenwriterBOList.push(
              {"screenwriter_id":screenwriter,
                "screenwriter_name":this.scenaristOptionsMap[screenwriter]})
        });
      }
      if(this.createScriptFormData.shootingArray){
        this.createScriptFormData.shootingArray.forEach(shooting => {
          postData.shootingBOList.push(
              {"shooting_id":shooting,
                "shooting_name":this.phtographerOptionsMap[shooting]})
        });
      }
      let res = await saveScriptData(postData);
      if (res.code === 0) {
        this.$message.success('创建成功');
        this.createScriptModalVisible = false;
        this.onCreateScriptOKLoading = false;
        this.getScriptTableList();
      }else{
        this.$message.success('创建失败，请重试！');
        this.createScriptModalVisible = false;
        this.onCreateScriptOKLoading = false;
        this.getScriptTableList();
      }
    },
    onScriptDateChange(val, dateString) {
      this.createScriptFormData.actorIdArray = [];
      this.getActorListByDate();
    },
    onDateRangeChange(val, dateString) {
      if (val.length === 0) {
        this.dates = [];
      }

      this.filterConditions.startUploadTime = dateString[0];
      this.filterConditions.endUploadTime = dateString[1];
      this.tablePagination.page = '1';
      this.getScriptTableList();
    },
    onCalendarChange(val) {
      this.dates = val;
    },
    // 编辑按钮
    onTableEditClick(record) {
      this.createScriptFormData = {
        id: record.makeId,
        makeName: record.makeName,
        actorIdArray: record.actorInfoList.map(act => {
          return act.actorId.toString();
        }),
        shootingArray: record.shootingBOList.map(act => {
          return act.shooting_id && act.shooting_id.toString();
        }),
        screenwriterArray: record.screenwriterBOList.map(act => {
          return act.screenwriter_id && act.screenwriter_id.toString();
        }),
        mouthPlay: record.mouthPlay,
        uploadTime: moment(record.uploadTime),
        projectCode: record.projectCode,
        shootingId: record.userId,
        screenwriterId: record.screenwriterId,
        deptId: record.deptId,
        mediaChannels: record.mediaChannelsArr.join(","),
        mediaChannelsArr: record.mediaChannelsArr.sort()
      };
      this.scenaristOptions = [{ label: record.screenwriterCode, value: record.screenwriterId }];
      this.phtographerOptions = [{ label: record.userCode, value: record.userId }];
      this.getActorListByDate();
      this.getScenaristListByJob();
      this.getPhotographerList();
      this.createScriptModalVisible = true;
    },
    //删除按钮
    async confirmDeleteScript(record) {
      let res = await deleteScriptData(record.makeCode);
      if (res.code === 0) {
        this.$message.success('删除成功!');
        this.getScriptTableList();
      }
    },
    onDeptChange(val) {
      this.createScriptFormData.screenwriterId = '';
      this.createScriptFormData.shootingId = '';
      this.getPhotographerList();
      this.getScenaristListByJob();
      console.error("================onDeptChange====================")
      this.getActorListByDate();
    },
    // 打开创建脚本对话框
    onCreateScriptBtnClick() {
      this.createScriptFormData = {
        actorIdArray: [],
        mouthPlay: 'MP',
        uploadTime: moment(),
      };
      this.getActorListByDate();
      this.createScriptModalVisible = true;
    },
    // 创建脚本对话框确认
    onCreateScriptOK() {
      this.onCreateScriptOKLoading = true ;
      console.error("================onCreateScriptOK===================="+this.onCreateScriptOKLoading)
      this.$refs.createScriptForm.validate().then(res => {
        this.saveScript();
      });
    },
    // 关闭新增弹窗事件
    onCreateScriptModalCancel() {
      this.$refs.createScriptForm.clearValidate();
    },

    onFilterBtnClick() {
      if (!this.filterConditions.startUploadTime || !this.filterConditions.endUploadTime) {
        this.$message.warn('请先选择一个日期');
        return;
      }
      this.getScriptTableList();
    },
    onResetFilterBtnClick() {
      this.filterConditions = {};
      this.defaultRange = [moment(), moment()];
      this.filterConditions.startUploadTime = moment().format('YYYY-MM-DD');
      this.filterConditions.endUploadTime = moment().format('YYYY-MM-DD');
      this.tablePagination.page = '1';
      this.dates = [];
      this.getScriptTableList();
    },
    onTableChange(pagination) {
      this.tablePagination.page = pagination.current.toString();
      this.tablePagination.limit = pagination.pageSize.toString();
      this.tablePagination.pageSize = pagination.pageSize;
      this.getScriptTableList();
    },
    getScriptNameListData() {
      getScriptNameListData().then(res => {
        this.scriptNameOptions = res.list.map(item => {
          return {
            label: item.makeName,
            value: item.id,
          };
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.video_script {
  display: flex;
  flex-direction: column;
}
.table-arr-box {
  margin: -8px;
  padding: 4px 8px;
  margin-top: 8px;
}
.table-arr-box:first-child {
  margin-top: -8px;
}
.table-arr-box + .table-arr-box {
  border-top: 1px solid #f0f0f0;
}
</style>
<style lang="less" >
.add_script_modal {
  .ant-modal-body {
    overflow: auto;
    padding: 12px 20px;
    .ant-form {
      min-width: 600px;
      .ant-form-item-label {
        line-height: 32px;
      }
    }
  }
}
</style>
